import "./style.scss";
interface IRemoveCouponModal {
    couponCode: string;
    handleClose: (value: React.SetStateAction<boolean>) => void;
    handleCodeRemove: () => void;
}

const RemoveCouponModal: React.FC<IRemoveCouponModal> = ({couponCode, handleClose, handleCodeRemove}) => {  

  return (
    <div className="remove-coupon-modal-body-wrapper">
      <h5>Are you sure you want to remove <em>{couponCode}</em> coupon code ?</h5>
      <div className="remove-coupon-button-wrapper">
        <button onClick={() => handleClose(false)}>No, I want this discount</button>
        <button onClick={handleCodeRemove}>Yes, I don't want this discount</button>
      </div>
    </div>
  );
};

export default RemoveCouponModal;
